import React, { useState } from "react";
import { updateItem, deleteItem } from "../api";

export default function ItemRow({ item, onChange }) {
  const [editing, setEditing] = useState(false);
  const [text, setText] = useState(item.text);
  const [fontColor, setFontColor] = useState(item.fontColor || "#ffffff");
  const [fontSize, setFontSize] = useState(item.fontSize || 40);

  async function save() {
    const updated = await updateItem(item._id, {
      text,
      fontColor,
      fontSize: Number(fontSize),
    });

    onChange(updated);
    setEditing(false);
  }

  async function setVisible(visible) {
    const updated = await updateItem(item._id, { visible });
    onChange(updated);
  }

  async function remove() {
    await deleteItem(item._id);
    onChange({ _id: item._id }, true);
  }

  return (
    <div style={{ padding: 12, borderBottom: "1px solid #ddd" }}>
      {editing ? (
        <input
          value={text}
          onChange={(e) => setText(e.target.value)}
          style={{ width: "100%", padding: 8 }}
        />
      ) : (
        <div style={{ color: item.fontColor, fontSize: item.fontSize }}>
          {item.text}
        </div>
      )}

      {editing && (
        <div style={{ display: "flex", gap: 12, marginTop: 8 }}>
          <input
            type="color"
            value={fontColor}
            onChange={(e) => setFontColor(e.target.value)}
          />

          <input
            type="number"
            min={10}
            max={200}
            value={fontSize}
            onChange={(e) => setFontSize(Number(e.target.value))}
            style={{ width: 70 }}
          />
        </div>
      )}

      <div style={{ marginTop: 8, display: "flex", gap: 12 }}>
        <label>
          <input
            type="radio"
            checked={item.visible === true}
            onChange={() => setVisible(true)}
          />{" "}
          Yes
        </label>

        <label>
          <input
            type="radio"
            checked={item.visible !== true}
            onChange={() => setVisible(false)}
          />{" "}
          No
        </label>

        {editing ? (
          <>
            <button onClick={save}>Save</button>
            <button
              onClick={() => {
                setEditing(false);
                setText(item.text);
                setFontColor(item.fontColor);
                setFontSize(item.fontSize);
              }}
            >
              Cancel
            </button>
          </>
        ) : (
          <button onClick={() => setEditing(true)}>Edit</button>
        )}

        <button onClick={remove} style={{ color: "red" }}>
          Delete
        </button>
      </div>
    </div>
  );
}
